import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
interface CaseStudySectionProps {
  title?: string;
  label?: string;
  sectionNumber?: string;
  children: React.ReactNode;
  className?: string;
  id?: string;
  darker?: boolean;
}
export function CaseStudySection({
  title,
  label,
  sectionNumber,
  children,
  className = '',
  id,
  darker = false
}: CaseStudySectionProps) {
  const {
    ref,
    isVisible
  } = useScrollReveal(0.1);
  return <section id={id} className={`py-24 md:py-32 px-6 ${darker ? 'bg-black' : 'bg-black'} ${className}`} data-id="element-103">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} data-id="element-104">
        {title && <div className="flex items-center gap-6 mb-16" data-id="element-105">
            <h2 className="text-2xl md:text-5xl font-mono uppercase tracking-wide text-white " data-id="element-106">
              {title}
            </h2>
            <div className="flex-grow relative h-px bg-white/30" data-id="element-107">
              {sectionNumber && <span className="absolute bottom-2 right-0 text-[10px] font-mono text-white/60 tracking-widest" data-id="element-108">
                  [{sectionNumber}]
                </span>}
            </div>
            {label && <span className="text-xs uppercase tracking-widest text-white/60 whitespace-nowrap" data-id="element-109">
                {label}
              </span>}
          </div>}
        {children}
      </div>
    </section>;
}